function ruleeditor() {
    /// <summary>
    /// This object provides js functions for the Widget.RuleEditor.RuleEditor.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 20.9.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.9.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
  this.assid = -1;
  this.rid = -1;
  this.dirty = false;
  this.startDate = '';
  this.endDate = '';
  this.templates = {};
}

ruleeditor.prototype = new window.vcTemplate();

ruleeditor.prototype.init = function () {
    /// <summary>
    /// This function sets heights and widths and inits all event handler.s
    /// </summary>
    var me = this;
    try {
      
        me.setListHeight();

        me.visual.find(".cssclocktimermenu").width(me.width - 60);
        me.visual.find(".csseditorframe,.cssdiveditor")
            .width(parseInt(me.width - me.visual.find(".cssleftmenu").width() - 40, 10));
        me.visual.find(".vc-rule-filter,#divDataItems").width(parseInt(me.visual.find(".cssleftmenu").width(), 10));

       
       // me.visual.find("#divDataItems").height(parseInt(me.visual.find(".cssleftmenu").width(), 10));

        me.visual.find(".csslsteditor .maxitemwidth").width(me.visual.find(".csseditorframe").width - 20);
        me.visual.find('#divSelection').show();
        me.visual.find('#divLoading').hide();
        
        me.initDataItemGroupEvents();
        me.initLoggerSelection();
        me.fillTemplates();
        me.initSortable();
        me.initValidation();
        me.initCancelButton();
        me.initSaveButton();
        me.initSelectionEvents();
      
        me.visual.find(".vc-rule-filter").vcFilter({ callback: function () { me.filter(); } });

        //init the double click handlers
        me.visual.find('#lst_operator, #lst_signal, #lst_meta, #lst_editor').off('dblclick', ".item").on("dblclick",
            ".item",
            function() {
                if (me.visual.find($(this)).parent('#lst_editor').length === 0) {
                    me.visual.find('#lst_editor').append($(this));
                    if ($(this).find('.rcatid' + me.rcatid_value).length > 0) {
                        me.validateValue($(this).find('.rcatid' + me.rcatid_value));
                    }
                } else {
                    $(this).remove();
                }
                me.initValidation();
                me.getExpression();
                me.resetTemplates();
                me.showSignalParam();
            });


        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};

/* Editor expression*/

ruleeditor.prototype.getRuleList = function () {
    /// <summary>
    /// This function builds the json object for saving the current rule.<br/>
    /// It iterates all items in the rule editor list and fills the object.
    /// </summary>
    var data = { 'therms': [] };
    var me = this;
    var item;
    var param;
    try {

        me.visual.find('#lst_editor li').each(function () {
            item = null;
            param = "";
            //ruleItem with value input
            if ($(this).find('.rcatid' + me.rcatid_value).length > 0) {
                item = $(this).find('.rcatid' + me.rcatid_value);
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': item.val(), 'assid': -1, 'rdtid': -1 });
            }
            if ($(this).find('.rcatid1').length > 0) {
                item = $(this).find('.rcatid1');
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': -1, 'rdtid': -1 });
            }
            //comparison
            if ($(this).find('.rcatid3').length > 0) {
                item = $(this).find('.rcatid3');
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': -1, 'rdtid': -1 });
            }
            //logic operator
            if ($(this).find('.rcatid8').length > 0) {
                item = $(this).find('.rcatid8');
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': -1, 'rdtid': -1 });
            }
            //signals
            if ($(this).find('.rcatid6').length > 0) {
                item = $(this).find('.rcatid6');
                param = $(this).find('.signalparam').html();
                if (typeof param === 'undefined') {
                    param = '';
                };
                data.therms.push({
                    'rtiid': item.attr('id'),
                    'parameter': param,
                    'assid': item.attr('assid'),
                    'rdtid': 2
                });
            }
            //meta types
            if ($(this).find('.rcatid5').length > 0) {
                item = $(this).find('.rcatid5');
                data.therms
                    .push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': item.attr('assid'), 'rdtid': 1 });
            }

            //rules
            if ($(this).find('.rcatid2').length > 0) {
                item = $(this).find('.rcatid2');
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': -1, 'rdtid': -1 });
            }

            //meta type - static values
            if ($(this).find('.rcatid7').length > 0) {
                item = $(this).find('.rcatid7');
                data.therms.push({ 'rtiid': item.attr('id'), 'parameter': '', 'assid': -1, 'rdtid': -1 });
            }

            item = null;

        });

        return data.therms;
    } catch (ex) {
        me.writeError('.getRuleList', ex);
        return new Object();
    }
};

ruleeditor.prototype.getExpression = function () {
    /// <summary>
    /// This is the main function for generating the expression based on the list items in the rule editor list.<br/>
    /// Basically it builds a formal js-expression which gets parsed by a js-parser. If the parsing is valid, the rule is valid!<br/>
    /// But not the js-expression gets stored for calculation later on - another expression gets build which contains placeholders for different
    /// item types (eg. analog signals, meta types, null values, static values ...). <br/>
    /// Conditionals get handled separately - only ONE SINGLE 'If ... then ... else' condition is possible (the closure handling gets too tricky if other!). 
    /// However, the parser allows more than one - if it's the case we add an invalid char to the js-expression to break the validation.
    /// </summary>
    var me = this;
    var sJS = '';
    var sEXPR = '';
    var sRule = '';
    var bIf = false;
    var bElse = false;
    var val;
    var param;
    me.visual.find('#lst_editor li').each(function () {

        //rule item with value input
        if ($(this).find('.rcatid' + me.rcatid_value).length > 0) {
            val = $(this).find('.rcatid' + me.rcatid_value).val();
            if (val.length > 0) {
                sJS += ' ' + val.replace(',', '.') + ' ';
                sEXPR += '(' + val.replace(',', '.') + ')';
            } else {
                //parse the rule as long as there is no value
                sJS += ')';
            }
        }
        //operators
        if ($(this).find('.rcatid1').length > 0) {
            sJS += $(this).find('.rcatid1').attr('js_op');
            sEXPR += ' ' + $(this).find('.rcatid1').attr('expr_op') + ' ';
        }
        //comparison
        if ($(this).find('.rcatid3').length > 0) {
            sJS += $(this).find('.rcatid3').attr('js_op');
            sEXPR += ' ' + $(this).find('.rcatid3').attr('expr_op') + ' ';
        }

        //logic operator
        if ($(this).find('.rcatid8').length > 0) {
            sJS += $(this).find('.rcatid8').attr('js_op');
            sEXPR += ' ' + $(this).find('.rcatid8').attr('expr_op') + ' ';
        }
        //signals
        if ($(this).find('.rcatid6').length > 0) {
            sJS += ' 0 ';
            param = $(this).find('.rcatid6 .signalparam').html();
            if (typeof param === 'undefined') {
                param = '';
            };
            sEXPR += '[bsaid=' + $(this).find('.rcatid6').attr('assid') + param + ']';
        }
        //meta types
        if ($(this).find('.rcatid5').length > 0) {
            sJS += ' 0 ';
            sEXPR += '[mtid=' + $(this).find('.rcatid5').attr('assid') + ']';
        }

        //rules
        if ($(this).find('.rcatid2').length > 0) {
            sRule = $(this).find('.rcatid2').attr('ruletype');
            switch (sRule) {
                case 'if':
                    bIf = true;
                    break;
                case 'then':
                    //needed hack to avoid empty condition - just destroy the grammar
                    if (sJS.charAt(sJS.length - 1) === '{') {
                        sJS += '{';
                    }
                    break;
                case 'else':
                    bElse = true;
                    break;
            }
            sJS += $(this).find('.rcatid2').attr('js_rule');
            sEXPR += $(this).find('.rcatid2').attr('expr_rule');
        }

        //meta type - static values
        if ($(this).find('.rcatid7').length > 0) {
            sJS += ' 0 ';
            sEXPR += '[static_value]';
        }
        //items with the line class set to full width
        $(this).filter('.line').css('min-width', me.width - 338);
    });


    if (bIf) {
        //needed hack to avoid conditionals without else branch!!
        if (bElse === false) {
            sJS += "}";
        } else {
            //needed hack to avoid empty condition - just destroy the grammar
            if (sJS.charAt(sJS.length - 1) === '{') {
                sJS += '{';
            }
        }
        sJS += '}';
        sEXPR += ')';
    }

    //try to parse - on error the rule is invalid!
    try {
        me.visual.find('#txtExpression').val(sEXPR);
        var parser = rules.parse(sJS);
        me.setValidationInfo(true);
        me.visual.find('#btnSave').button('enable');
        me.dirty = true;
        me.visual.find('#txtJS').val(parser.print('', ' '));

        parser = null;
    } catch (ex) {

        // ReSharper disable once VariableUsedOutOfScope
        parser = null;
        me.visual.find('#btnSave').button('disable');
        me.dirty = false;
        me.visual.find('#txtJS').val(me.resources.inputInvalid);
        me.setValidationInfo(false);
        me.visual.find('#spanResult').html(me.setValidationInfo(false));
    }
};

/* data handling */
ruleeditor.prototype.deleteRule = function (rid) {
    /// <summary>
    /// This function handles the deleting of an existing rule. After deleting the selection overview gets reloaded.
    /// </summary>
    /// <remarks>NOTE: The trick is that we send a rule id (rid) with an empty list of rule therms - so, the whole rule gets deleted.</remarks>
    var me = this;
    try {
        if (confirm(me.resources.askDel, me.resources.validation)) {
            var param = { 'rid': rid, 'rule': '', 'assid': -1, 'rdtid': -1, 'therms': [] };
            var sParam = JSON.stringify(param);
            window.VisualCoreService.updateData(me.vcvid,
                me.vcgid,
                getCurrentTimestamp(),
                me.height,
                me.width,
                me.parameter,
                me.signalParameter,
                me.deviceType,
                me.langid,
                sParam,
                function (result) {
                    if (result == null) {
                        return false;
                    }

                    if (result === false) {
                        alert(me.resources.errorSave + '"!');
                        me.visual.find('.divSelectionWaiting').hide();
                    }
                    me.reloadSelection();
                    _VCMQ.produce(me.visual, me.vcgid, 'RULE_CLOSE', '');
                    return true;
                });
        }
    } catch (ex) {
        me.writeError('.deleteRule', ex);
        return false;
    }

    return false;
};


ruleeditor.prototype.prepareSaving = function () {
    /// <summary>
    /// This function saves the current rule. <br/>
    /// It gets the json object with all rule therms and sends it to the server for updating.
    /// </summary>
    var me = this;
    try {

        if (me.visual.find('#txtRuleName').hasClass('formItemInvalid')) {
            alert(me.resources.invalidTitle);
            return false;
        }
        if (me.recalcRules) {
            var duration = moment.duration(moment(me.startDate, "DD.MM.YYYY").diff(moment()));
            var days = parseInt(duration.asDays());
            if (days < 0) {
                me.openAskDialog(me.resources.wannaRecalcRule,
                    { at: 'center center-30%', of: window },
                    function() { me.save(true) },
                    function() { me.save(false); });
                return true;
            } else {
                me.save(false);
            }
        } else {
            me.save(false);
        }


    } catch (ex) {
        console.info(ex);
        me.writeError('.prepareSaving', ex);
        return false;
    }

    return false;
};


ruleeditor.prototype.save = function (doRecalc) {
    /// <summary>
    /// This function saves the current rule. <br/>
    /// It gets the json object with all rule therms and sends it to the server for updating.
    /// </summary>
    var me = this;
    try {

        if (me.visual.find('#txtRuleName').hasClass('formItemInvalid')) {
            alert(me.resources.invalidTitle);
            return false;
        }

        me.visual.find('#divSaving').show();
        //send it to the server for updating
        //build the full json object including the rule therm list
        var bSelected = me.visual.find('#chbSelected').prop('checked');
        var bPrivate = me.visual.find('#chbPrivate').prop('checked');
        var bUseDailyValues = me.visual.find('#chbUseDailyValues').prop('checked');
        var bReplaceNullValues = me.visual.find('#chbReplaceNullValues').prop('checked');
        var ruleInfo = {
            'name': me.visual.find('#txtRuleName').val(),
            'unit': me.visual.find('#txtRuleUnit').val(),
            'description': me.visual.find('#txtRuleDescription').val(),
            'selected': bSelected,
            'privateRule': bPrivate,
            'startdate': me.startDate,
            'enddate': me.endDate,
            'useDailyValues': bUseDailyValues,
            'replaceNullValues': bReplaceNullValues
        };
      
        if (me.showClockTimer) {
            ruleInfo.clocktimer = me.visual.find('#txtClockTimer').html();
        }
        var param = {
            'rid': me.rid,
            'rule': me.visual.find('#txtExpression').val(),
            'assid': me.assid,
            'rdtid': me.rdtid,
            'therms': me.getRuleList(),
            'ruleinfo': ruleInfo, 
            'doRecalc': doRecalc
        };

        var sParam = JSON.stringify(param);
        window.VisualCoreService.updateData(me.vcvid,
            me.vcgid,
            getCurrentTimestamp(),
            me.height,
            me.width,
            me.parameter,
            me.signalParameter,
            me.deviceType,
            me.langid,
            sParam,
            function (result) {

                if (result !== true) {
                    if (result === false) {
                        alert(me.resources.errorSave + '!');
                    } else {
                        alert(result);
                        me.visual.find('#divSaving').hide();
                        return false;
                    }
                    me.visual.find('#divSaving').hide();
                }
                _VCMQ.produce(me.visual, me.vcgid, 'RULE_CLOSE', '');

                //after closing the editor form we have to reload the selection overview
                me.reloadSelection();
                me.close();
                return true;
            });
    } catch (ex) {
        me.writeError('.save', ex);
        return false;
    }

    return false;
};

ruleeditor.prototype.deleteRule = function (rid) {
    /// <summary>
    /// This function handles the deleting of an existing rule. After deleting the selection overview gets reloaded.
    /// </summary>
    /// <remarks>NOTE: The trick is that we send a rule id (rid) with an empty list of rule therms - so, the whole rule gets deleted.</remarks>
    var me = this;
    try {


        if (confirm(me.resources.askDel, me.resources.validation)) {
            var param = { 'rid': rid, 'rule': '', 'assid': -1, 'rdtid': -1, 'therms': [] };
            var sParam = JSON.stringify(param);
            window.VisualCoreService.updateData(me.vcvid,
                me.vcgid,
                getCurrentTimestamp(),
                me.height,
                me.width,
                me.parameter,
                me.signalParameter,
                me.deviceType,
                me.langid,
                sParam,
                function (result) {
                    if (result == null) {
                        return false;
                    }

                    if (result === false) {
                        alert(me.resources.errorSave + '"!');
                        me.visual.find('.divSelectionWaiting').hide();
                    }
                    me.reloadSelection();
                    _VCMQ.produce(me.visual, me.vcgid, 'RULE_CLOSE', '');
                    return true;
                });
        }
    } catch (ex) {
        me.writeError('.deleteRule', ex);
        return false;
    }

    return false;
};

ruleeditor.prototype.reloadSelection = function () {
    /// <summary>
    /// Gets the key-value list from the input fields and send it to the server for updating.
    /// </summary>
    var me = this;
    var vcC = new vcCommon();
    me.visual.find('#divSelection').html(vcC.getLoadingIcon());
    vcC = null;
    try {
        //send it to the server for updating
        var param = { 'type': 1, 'parameter': '' };
        var sParam = JSON.stringify(param); //add 1 for reloading selection 


        window.VisualCoreService.getData(me.vcvid,
            me.vcgid,
            getCurrentTimestamp(),
            me.height,
            me.width,
            me.parameter,
            me.signalParameter,
            me.deviceType,
            me.langid,
            sParam,
            function (result) {
                if (result == null) {
                    result = '';
                }
                me.visual.find('#divSelection').html(result);
                me.initSelectionEvents();
                return true;
            });
    } catch (ex) {
        me.writeError('.reloadSelection', ex);
        return false;
    }

    return false;
};

/* sortable list */

ruleeditor.prototype.initSortable = function () {
    /// <summary>
    /// This function inits all sortable lists and adds event handlers for drag'n drop events
    /// </summary>
    var me = this;
    me.visual.find('.sortable').sortable({
        tolerance: 'pointer',
        cancel: 'input',
        connectWith: '.connectedSortable',
        placeholder: 'ruleplaceholder',
        over: function(ui, event) { me.onOver(event, ui) },
        start: function(ui, event) { me.onOver(event, ui) },
        stop: function(ui, event) { me.onOut(event, ui) },
        out: function(ui, event) { me.onOut(event, ui) },
        update: function(ui, event) { me.onUpdate(ui, event) },
        receive: function(event, ui) { me.onReceive(ui.sender, ui.item); }
    });
};

ruleeditor.prototype.onOver = function(event) {
    var me = this;
    me.visual.find('#lst_editor .item').addClass('maxitemwidth');
    me.visual.find(event.item).removeClass('maxitemwidth');
    me.visual.find('.sortable').sortable('refreshPositions');
};

ruleeditor.prototype.onOut = function() { this.visual.find('#lst_editor .item').removeClass('maxitemwidth');};

ruleeditor.prototype.onUpdate = function() { this.getExpression();};

ruleeditor.prototype.onReceive = function (sender, item) {
    /// <summary>
    ///  This event is triggered when the editor receives an item from another list.
    ///  It reinits validation and recalculates the exression.
    /// </summary>
    var me = this;
    try {
    me.visual.find('#lst_editor .item').removeClass('maxitemwidth');
//handle static values
    if (item.find('.rcatid' + me.rcatid_value).length > 0) {
        me.validateValue(item.find('.rcatid' + me.rcatid_value));
    }
    //reinit input value validation
    this.initValidation();
    me.getExpression();
    //refill all sortable lists except lst_editor
    me.resetTemplates();
    me.showSignalParam();

    } catch (ex) {me.writeError('.onReceive', ex);}

};

/* js events */

ruleeditor.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find("#divDataItems .item").removeClass("found").data("counter", 0).hide();
        ////we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-rule-filter", "#divDataItems li", "found");
        me.visual.find("#divDataItems .item.found").show();

        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};

ruleeditor.prototype.initValidation = function () {
    /// <summary>
    /// This event is triggered when a value has been edited in a number input rule item
    /// </summary>
    var me = this;
    me.visual.find('#lst_editor').find('.rcatid' + me.rcatid_value).unbind('keyup').keyup(function() {
        me.validateValue(this);
        me.getExpression();
    });
};

ruleeditor.prototype.validateValue = function (item) {
    /// <summary>
    /// This function handles the numeric validation for input fields 
    /// </summary>
    var me = this;
    try {
    var val = $(item).val();
    if (validateNumeric(val)) {
        $(item).removeClass('formItemInvalid');
    } else {
        $(item).addClass('formItemInvalid');
    }
    } catch (ex) { me.writeError('.validateValue', ex); }
};

ruleeditor.prototype.initDataItemGroupEvents = function () {
    /// <summary>
    /// Simple event handler for the showing/hiding of list entries in the data item lists.
    /// </summary>
    var me = this;
    me.visual.find('.dataItemGroup').unbind('click').click(function() {
        if ($(this).parent().find('.dataItemGroupList').css('display') === 'none') {
            $(this).parent().find('.dataItemGroupList').css('display', 'inline-block');
        } else {
            $(this).parent().find('.dataItemGroupList').css('display', 'none');
        }
    });
};

ruleeditor.prototype.fillTemplates = function () {
    /// <summary>
    /// This function fills a json list with the html string of each sortable list.
    /// Later on it is used to refill the sortables after an item has been moved to another list.
    /// Without that functionality an item can only get selected once! 
    /// </summary>
    var me = this;
    try {
    me.templates = {};
    me.visual.find('.sortable').each(function() {
        me.templates[$(this).prop('id')] = $(this).html();
    });
    } catch (ex) { me.writeError('.fillTemplates', ex); }
};

ruleeditor.prototype.resetTemplates = function () {
    /// <summary>
    /// This function refills all sortable lists with their initial html string.
    /// </summary>
    var me = this;
    try {
// ReSharper disable once MissingHasOwnPropertyInForeach
    for (var key in me.templates) {
        if (key !== 'lst_editor') {
            me.visual.find('#' + key).html(me.templates[key]);
            me.filter();
        }
    }
    } catch (ex) { me.writeError('.resetTemplates', ex); }
    return '';
};

ruleeditor.prototype.setValidationInfo = function (bValid) {
    /// <summary>
    /// This function shows/hides the error message and background style of the rule editor on error state.  
    /// </summary>
    var me = this;
    try {
    if (me.visual.find('#lst_editor').html().length < 25) {
        return '';
    }
    if (bValid) {
        me.visual.find('#lst_editor').removeClass('invalid').addClass('valid');
        me.visual.find('.ruleerror').fadeOut();
    } else {
        me.visual.find('#lst_editor').removeClass('valid').addClass('invalid');
        me.visual.find('.ruleerror').fadeIn();
    }
    } catch (ex) { me.writeError('.setValidationInfo', ex); }
    return true;
};

ruleeditor.prototype.validateTitle = function () {
    /// <summary>
    /// This function handles the string validation for the rule title.
    /// </summary>
    var me = this;
    try {
        var val = me.visual.find('#txtRuleName').val();
        var bValid;
        //'objects need some string converting :-)
        if (val == null) {
            val = '';
        } else {
            val = val + '';
        };
        val = trimAll(val);
        if ((val.length < me.ruleTitleMinLength) || (val.length > me.ruleTitleMaxLength)) {
            me.visual.find('#txtRuleName').removeClass('formItemValid').addClass('formItemInvalid')
                .css('background-color', '#fff');
            bValid = false;
        } else {
            me.visual.find('#txtRuleName').removeClass('formItemInvalid').addClass('formItemValid')
                .css('background-color', '#fff');
            bValid = true;
        }
        me.enableSaveButton(bValid);
        return false;
    } catch (ex) {
        me.writeError('.validateTitle', ex);
        return false;
    }

};

ruleeditor.prototype.validateDate = function (dt) {
    /// <summary>
    /// This function andles the string validation for the rule dates.
    /// </summary>
    var me = this;
    try {

        var val = dt.val();
        if (val == null) {
            val = '';
        } else {
            val = val + '';
        };
        val = trimAll(val);
        if (val.length > 0) {
            if (isDate(val) === false) {
                dt.removeClass('formItemValid').addClass('formItemInvalid').css('background-color', '#fff');
                return false;
            } else {
                dt.removeClass('formItemInvalid').addClass('formItemValid').css('background-color', '#fff');
                return true;
            }
        }
        return true;
    } catch (ex) { me.writeError('.validateDate', ex); return false;
    }

};

ruleeditor.prototype.ruleInfoHandler = function () {
    /// <summary>
    /// This function  
    /// </summary>
    var me = this;
    try {
//validate rule title on every keyup
    me.visual.find('#txtRuleName').keyup(function() { me.validateTitle() });
    me.visual.find('#txtRuleName').change(function() { me.validateTitle() });
    me.visual.find('#chbSelected').click(function() { me.enableSaveButton(true) });
    me.visual.find('#chbPrivate').click(function() { me.enableSaveButton(true) });
    if (me.showClockTimer) {
        me.visual.find('.cssclocktimermenu .cl').click(function() { me.validateTitle() });
    }
    } catch (ex) { me.writeError('.ruleInfoHandler', ex); }
};

ruleeditor.prototype.close = function () {
    /// <summary>
    /// Generates the function for closing/hiding the editor form.
    /// Resets the dirty input field and shows/hides forms.
    /// </summary>
    var me = this;
    me.dirty = false;
    me.visual.find('.divSelectionWaiting').hide();
    me.visual.find('#divSaving').hide();
    me.visual.find('#divSelection').show();
    me.visual.find('#divEditForm').hide();
    return false;
};

ruleeditor.prototype.initCancelButton = function () {
    /// <summary>
    /// Generates the function for the cancel button in the editor form.
    /// </summary>
    var me = this;
    try {
    me.visual.find('#btnCancel').button().unbind('click').click(function() {
        if (me.dirty === true) {
            if (confirm(me.resources.askCancel, me.resources.validation) === false) {
                return false;
            }
        }
        me.close();

        return false;
    });
    } catch (ex) { me.writeError('.initCancelButton', ex); }
};

ruleeditor.prototype.showSignalParam = function() {
    /// <summary>
    /// Adds an event handler for optional signal parameter (used in alarm signals)
    /// </summary>
    return false;
};

ruleeditor.prototype.initSaveButton = function () {
    /// <summary>
    /// Generates the js-event handler for the save button.  
    /// </summary>
    var me = this;
    try {
    me.visual.find('#btnSave').button().click(function() {
        me.prepareSaving();
        return false;
    }).button('disable');
    } catch (ex) { me.writeError('.initSaveButton', ex); }
};

ruleeditor.prototype.enableSaveButton = function (valid) {
    /// <summary>
    /// Generates the js-event handler for the save button.
    /// </summary>
    var me = this;
    try {
    if (valid) {
        if (me.visual.find('#lst_editor').hasClass('valid')) {
            me.visual.find('#btnSave').button('enable');
        }
    } else {
        me.visual.find('#btnSave').button('disable');
    }
    } catch (ex) { me.writeError('.enableSaveButton', ex); }
};


ruleeditor.prototype.setListHeight = function () {
    /// <summary>
    /// we have to dynamically adjust the height of the dataItems 
    /// </summary>
    var me = this;
    try {
  var dataItemHeight = me.height-110;

 if (dataItemHeight < 0) {dataItemHeight = 600} 

 if (me.visual.find('#divRuleInfo').length>0) {
   dataItemHeight -= me.visual.find('#divRuleInfo').height();
 } 
 if (me.visual.find('#divDDLLogger').length>0) {
    dataItemHeight -= me.visual.find('#divDDLLogger').height()+20;
  } 
  if (me.visual.find('.cssclocktimermenu').length>0) {
    dataItemHeight -= me.visual.find('.cssclocktimermenu').height();
  } 
  if (me.visual.find('.vc-rule-filter').length>0) {
    dataItemHeight -= (me.visual.find('.vc-rule-filter').height()+10);
  } 
  me.visual.find('#divDataItems').height(dataItemHeight);



} catch (ex) { me.writeError('.setListHeight', ex); }
};




function RuleViewerSignalAnalog() {
    /// <summary>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 17.09.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 17.9.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  
};
RuleViewerSignalAnalog.prototype = new window.ruleeditor();

RuleViewerSignalAnalog.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
     
        me.initSelectionEvents();
        return true;
    } catch (ex) {
        me.writeError("init", ex);
        return false;
    }
};

RuleViewerSignalAnalog.prototype.initSelectionEvents = function() {
    var me = this;
    try {
        
     me.visual.find('.vc-list-item').removeClass('alt');
     me.visual.find('.vc-list-item:even').addClass('alt');

       //add js handler for the del button
       me.visual.find('.iconDelRule').unbind('click').click(function(e) {
         var rid = $(this).attr('id').replace('btnDel_', '');
         me.deleteRule(rid);
         _VCMQ.produce(me.visual, me.vcgid, 'RULE_REFRESH', '');
         e.stopPropagation();
       });

       //add js handler for the add button
       me.visual.find('#btnAddRule').unbind('click').click(function() {
         var param = JSON.parse(me.parameter);
         //alert("add:" + param.bsaid );

       //  me.reloadSelection();
           me.showMe(param.bsaid, -1);
       }).button();

    ////send a notification when the edit form gets canceled
    //   me.visual.find('#btnCancel, #btnCancelRule, #btnSave').click(function() {
    // _VCMQ.produce($('#divVisualcoreContainer" & VCGID & "'), '" & VCGID & "', 'RULE_REFRESH', '');
     //  });

  return false;
 } catch (ex) { writeError('initSelectionEvents', ex); return false;}

 
}; 


RuleViewerSignalAnalog.prototype.showMe = function (bsaid, rid) {
    var me = this;
    try {
       // alert("show");
      
        showModalPopup("<div id='divRuleEditorXXX'></div>", 655, 810);

       // console.info(me);
        me.vcVisual.addVisualBase('divRuleEditorX', 275, "XX", getCurrentTimestamp(), 0, 810, JSON.stringify({ "bsaid": bsaid, "rid": rid }), "", 1);

        return false;
    } catch (ex) { writeError('initSelectionEvents', ex); return false; }


};


//#END REGION FILTER